import { useEffect } from 'react';
/**
 * Listen for a given key code and invoke passed handler when received.
 */
export const useKeyDown = ({ onKeyDown, enabled = true, key }) => {
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const handleKeyDown = (event) => {
            if (event.key !== key) {
                return;
            }
            onKeyDown();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onKeyDown, enabled, key]);
};
